import { Option } from "@storeblocks/select";
import { Select } from "Components/Form/Select";
import { getError } from "Utils/productUtils";
import { FormikProps } from "formik";
import React from "react";

interface Props {
  fieldName: string;
  formProps: FormikProps<any>;
  options: Option[];
  label: string;
  hint: string;
}

export const ChooseDeductible = ({
  fieldName,
  formProps,
  options,
  label,
  hint,
}: Props): React.ReactElement => {
  return (
    <Select
      large
      id={fieldName}
      name={fieldName}
      label={label}
      options={options}
      error={getError(fieldName, formProps)}
      labelPopoverProps={{ children: hint }}
    />
  );
};
